import React, { Fragment } from 'react'
import PropTypes from 'prop-types'

import i18n from 'Pods/Shared/I18n'
import InputField from 'Pods/Shared/InputField'

import CoverImage from 'images/cover.jpg'
import UserCoverEdit from './Components/UserCoverEdit'
import UserCoverActions from './Components/UserCoverActions'


class UserCoverImage extends React.Component {
  constructor(props) {
    super(props)

    this.state = {
      src: props.imageSrc,
      prevSrc: '',
      isInEditMode: false,
      showCoverImage: false,
      isWithControls: false,
    }

    this.croppie = null

    this.imgRef = React.createRef()
    this.imgContainerRef = React.createRef()

    this.handleCoverUpload = this.handleCoverUpload.bind(this)
    this.handleSubmit = this.handleSubmit.bind(this)
    this.handleCancel = this.handleCancel.bind(this)
    this.handleCropp = this.handleCropp.bind(this)
    this.handleCoverEdit = this.handleCoverEdit.bind(this)
    this.handleCoverEditEnd = this.handleCoverEditEnd.bind(this)
  }

  componentDidMount() {
    setTimeout(
      () => {
        const userNameMatches = App.config.username === this.props.userName

        this.setState({
          showCoverImage: !!(userNameMatches || this.state.src),
          isWithControls: userNameMatches,
        })
      },
      1000
    )
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.imageSrc !== this.props.imageSrc) {
      this.setState({ src: this.props.imageSrc })
    }
  }

  handleCoverUpload(event) {
    const file = event.target.files[0]
    const reader = new FileReader()

    reader.readAsDataURL(file)
    reader.onloadend = this.handleCoverEdit
  }

  handleCoverEdit(event) {
    this.setState({
      src: event.target.result,
      isInEditMode: true,
    }, this.handleCropp)
  }

  handleCropp() {
    const Croppie = require('croppie')

    this.croppie = new Croppie(this.imgRef.current, {
      viewport: {
        width: 1488,
        height: 200,
      },
      boundary: {
        height: 200,
      },
      showZoomer: false,
      enableOrientation: true,
      customClass: 'user-cover__croppie',
      enableResize: true,
    })
  }

  handleSubmit(event) {
    const cropParams = { type: 'blob', size: 'original', format: 'jpeg' }

    event.preventDefault()

    this.croppie.result(cropParams)
      .then((blob) => {
        cropParams.type = 'base64'

        this.croppie.result(cropParams)
          .then((src) => {
            this.handleCoverEditEnd(src, blob)
          })
      })
  }

  handleCancel(event) {
    event.preventDefault()

    this.handleCoverEditEnd('')
  }

  handleCoverEditEnd(src, blob) {
    if (blob) {
      this.setState({
        src,
        isInEditMode: false,
      }, this.props.handleImageUpload(blob))

      if (this.croppie) {
        this.croppie.destroy()
      }
    } else {
      this.setState({
        src: this.props.imageSrc,
        isInEditMode: false,
      })

      if (this.croppie) {
        this.croppie.destroy()
      }
    }
  }

  render() {
    const coverClassName = `user-cover${this.state.showCoverImage ? '' : ' user-cover--empty'}`

    return (
      <div
        className={coverClassName}
        onSubmit={this.handleSubmit}
        ref={this.imgContainerRef}
      >
        {this.state.showCoverImage && (
        <Fragment>
          <img
            src={this.state.src || CoverImage}
            ref={this.imgRef}
          />
          {!this.props.isResponsive && this.state.isWithControls && (
            <Fragment>
              {this.state.isInEditMode ? (
                <UserCoverEdit
                  icon="arrows"
                  text={i18n.t('drag_cover_text', { ns: 'profile' })}
                  className="user-cover__edit--with-text"
                />
              ) : (
                <label htmlFor="coverImageFileInput">
                  <UserCoverEdit icon="edit" />
                </label>
              )}
              <InputField
                inputClassName="user-cover__input"
                formClassName="user-cover__form-group"
                type="file"
                accept="image/*"
                name="coverImageFileInput"
                id="coverImageFileInput"
                onChange={this.handleCoverUpload}
              />
              {this.state.isInEditMode && (
                <UserCoverActions onSubmit={this.handleSubmit} onCancel={this.handleCancel} />
              )}
            </Fragment>
          )}
        </Fragment>
        )}
      </div>
    )
  }
}

UserCoverImage.propTypes = {
  isResponsive: PropTypes.bool.isRequired,
  imageSrc: PropTypes.string,
  userName: PropTypes.string,
  handleImageUpload: PropTypes.func,
}

UserCoverImage.defaultProps = {
  imageSrc: '',
  userName: '',
  handleImageUpload: () => {},
}

export default UserCoverImage
